export const MAX_SEARCH_RESULTS = 15;
